import React from "react";
import { Circle, Group, Text, Line } from "react-konva";

class State extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      // color: "#e9eaea",
      color: props.color,
      lastClick: 0,
      radius: 30,
      radiusSmall: 25,
      draggable: this.props.draggable,
      stroke: "black",
      strokeWidth: 1,
      type: this.props.type,
      isInitial: this.props.isInitial,
      isFinal: this.props.isFinal,
      visible: true,
      text: this.props.text, //esse valor que eu uso como identificador
      x: this.props.x,
      y: this.props.y,

      //cur = current, estado de origem da regra
      //fut = future, estado final da regra

      //--- apenas as transiçoes usam current e future

      location: this.props.location,
    };
  }

  updatePositions = (machineTransition, setMachineTransition) => {
    // const state = inst.state.text;

    let array = [...machineTransition];
    machineTransition.forEach((machineElement) => {
      if (machineElement != null) {
        const initialState = machineElement.initial;
        const futureState = machineElement.final;
        if (initialState.text === this.state.text) {
          let changeElement = Object.assign(machineElement, {
            initial: {
              text: this.props.text,
              xPos: this.props.x,
              yPos: this.props.y,
            },
            final: futureState,
          });

          const index = array.indexOf(machineElement);
          array.splice(index, 1, changeElement);

          // machineElement.setState({
          //   xcur: this.state.x,
          //   ycur: this.state.y,
          //   initial: {
          //     ...machineElement.state.initial,
          //     xPos: this.state.x,
          //     yPos: this.state.y,
          //   },
          // });

          // const transition = machineElement.getTransition(
          //   initialState,
          //   futureState,
          //   childs1
          // );
          // machineElement.setState({
          //   xfut: transition.state.final.xPos,
          //   yfut: transition.state.final.yPos,
          // });

          // machineElement.updateTransitionPosition();
        }

        if (machineElement.final.text === this.state.text) {
          let changeElement = Object.assign(machineElement, {
            final: {
              text: this.props.text,
              xPos: this.props.x,
              yPos: this.props.y,
            },
          });
          const index = array.indexOf(machineElement);
          array.splice(index, 1, changeElement);

          // setMachineTransition(array);
          //   machineElement.setState({
          //     xfut: this.state.x,
          //     yfut: this.state.y,
          //     final: {
          //       ...machineElement.state.final,
          //       xPos: this.state.x,
          //       yPos: this.state.y,
          //     },
          //   });
          //   const transition = machineElement.getTransition(
          //     initialState,
          //     futureState
          //     // childs1
          //   );
          //   machineElement.setState({
          //     xcur: transition.state.initial.xPos,
          //     ycur: transition.state.initial.yPos,
          //   });
          //   machineElement.updateTransitionPosition();
        }
        setMachineTransition(array);
      }
    });
  };

  // updatePositions = (childs1) => {
  //   // const state = inst.state.text;

  //   let array = [...childs1];
  //   array.forEach((machineElement) => {
  //     if (machineElement != null) {
  //       const typeElement = machineElement.constructor.name;
  //       if (typeElement == "Transition") {
  //         const initialState = machineElement.state.initial;
  //         const futureState = machineElement.state.final;
  //         if (initialState.text === this.state.text) {
  //           machineElement.setState({
  //             xcur: this.state.x,
  //             ycur: this.state.y,
  //             initial: {
  //               ...machineElement.state.initial,
  //               xPos: this.state.x,
  //               yPos: this.state.y,
  //             },
  //           });

  //           const transition = machineElement.getTransition(
  //             initialState,
  //             futureState,
  //             childs1
  //           );
  //           machineElement.setState({
  //             xfut: transition.state.final.xPos,
  //             yfut: transition.state.final.yPos,
  //           });

  //           machineElement.updateTransitionPosition();
  //         }

  //         if (machineElement.state.final.text === this.state.text) {
  //           machineElement.setState({
  //             xfut: this.state.x,
  //             yfut: this.state.y,
  //             final: {
  //               ...machineElement.state.final,
  //               xPos: this.state.x,
  //               yPos: this.state.y,
  //             },
  //           });
  //           const transition = machineElement.getTransition(
  //             initialState,
  //             futureState,
  //             childs1
  //           );
  //           machineElement.setState({
  //             xcur: transition.state.initial.xPos,
  //             ycur: transition.state.initial.yPos,
  //           });

  //           machineElement.updateTransitionPosition();
  //         }
  //       }
  //     }
  //   });
  // };
  changeCursor = (e, type) => {
    const container = e.target.getStage().container();
    container.style.cursor = type;
  };
  deleteState = (childs) => {
    this.setState({ visible: false });
    childs.forEach((machineElement) => {
      if (machineElement != null) {
        const typeElement = machineElement.constructor.name;
        if (typeElement === "Transition") {
          if (
            machineElement.props.initial.text === this.state.text ||
            machineElement.props.final.text === this.state.text
          ) {
            machineElement.setState({ visible: false });
          }
        }
      }
    });
  };

  render() {
    return (
      <Group>
        {this.state.visible && (
          <Group>
            {this.props.isInitial === true && (
              <Line
                points={[
                  this.props.x - 50,
                  this.props.y - 20,
                  this.props.x - 30,
                  this.props.y,
                  this.props.x - 50,
                  this.props.y + 20,
                ]}
                stroke={this.state.stroke}
                strokeWidth={this.state.strokeWidth}
              />
            )}

            <Circle
              id={this.props.id}
              x={this.props.x}
              y={this.props.y}
              radius={30}
              fill={this.props.color}
              draggable={this.props.draggable && true}
              stroke={"black"}
              strokeWidth={1}
              onClick={(e) => {
                this.props.onClick(e, this);
              }}
              onDragEnd={(e) => {
                this.props.onDragEnd(e, this);
              }}
              onMouseEnter={(e) => {
                this.changeCursor(e, "pointer");
              }}
              onMouseLeave={(e) => {
                this.changeCursor(e, "");
              }}
              onTap={(e) => {
                this.props.onTap(e, this);
              }}
              onTouchStart={(e) => {
                this.props.onTouchStart(e, this);
              }}
              onTouchEnd={(e) => {
                this.props.onTouchEnd(e, this);
              }}

              // onContextMenu={(e) => {
              //   this.props.onContextMenu(e);
              // }}
            />
            {this.props.isFinal === true && (
              <Circle
                id={this.props.id}
                x={this.props.x}
                y={this.props.y}
                radius={this.state.radiusSmall}
                fill={this.props.color}
                draggable={this.props.draggable && true}
                stroke={this.state.stroke}
                strokeWidth={this.state.strokeWidth}
                onDragEnd={(e) => this.props.onDragEnd(e, this)}
                onMouseEnter={(e) => {
                  this.changeCursor(e, "pointer");
                }}
                onClick={(e) => {
                  this.props.onClick(e, this);
                }}
                onMouseLeave={(e) => {
                  this.changeCursor(e, "");
                }}
                onTap={(e) => {
                  this.props.onTap(e, this);
                }}
                onTouchStart={() => {
                  this.props.onTouchStart();
                }}
                onTouchEnd={(e) => {
                  this.props.onTouchEnd(e, this);
                }}
              />
            )}
            <Text
              x={this.props.x - 5}
              y={this.props.y - 3}
              text={this.props.text}
              draggable={this.props.draggable || true}
              onDragEnd={(e) => {
                this.props.onDragEnd(e, this);
              }}
              onClick={(e) => {
                this.props.onClick(e, this);
              }}
              onMouseEnter={(e) => {
                this.changeCursor(e, "pointer");
              }}
              onMouseLeave={(e) => {
                this.changeCursor(e, "");
              }}
            />
          </Group>
        )}
      </Group>
    );
  }
}
export default State;
